const ROLE = {
  ADMIN: "адмін",
  MANAGER: "менеджер",
  ENGINEER: "інженер",
  ESTIMATOR: "кошторисник",
  WORKER: "монтер",
};
export { ROLE };
